import { IBillingMethods, ICheckoutState } from '../../interfaces';
import { CREDIT_CARD } from './constants';
import { isValidEmail } from './isValidEmail';
import { validatePassword } from './isValidPassword';

const validateFormForThirdParty = (form: ICheckoutState) => {
  const { email, password, shipCountry, shipState, shipZip, shipZipError } = form;

  return (
    isValidEmail(email.trim()) &&
    validatePassword(password.trim()) &&
    shipCountry.trim().length !== 0 &&
    (shipCountry === 'GB' ||
      (shipCountry !== 'GB' && shipState.trim().length !== 0)) &&
    shipZip.trim().length !== 0 &&
    !shipZipError
  );
};

const validateForm = (form: ICheckoutState, billingMethod: IBillingMethods) => {
  if (billingMethod === CREDIT_CARD) {
    const { email, password, shipCountry, shipState, shipZip, shipZipError } = form;

    return (
      isValidEmail(email.trim()) &&
      validatePassword(password.trim()) &&
      shipCountry.trim().length !== 0 &&
      (shipCountry === 'GB' ||
        (shipCountry !== 'GB' && shipState.trim().length !== 0)) &&
      shipZip.trim().length !== 0 &&
      !shipZipError
    );
  }
  return validateFormForThirdParty(form);
};

export { validateForm };
